(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-recipes"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-prp-fade]').forEach(function (el) {
    io.observe(el);
  });
  document.querySelectorAll('[data-prp-stagger]').forEach(function (group) {
    Array.from(group.children).forEach(function (child, i) {
      child.style.setProperty('--prp-i', Math.min(i, 5));
      io.observe(child);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-rice-recipes"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-prp-fade]').forEach(function (el) {
    io.observe(el);
  });
  document.querySelectorAll('[data-prp-stagger]').forEach(function (group) {
    Array.from(group.children).forEach(function (child, i) {
      child.style.setProperty('--prp-i', Math.min(i, 5));
      io.observe(child);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
